export class EntityIdentifierError<TEntity> extends Error {
  /**
   * Class constructor
   *
   * @param {string} message Error message
   * @param {*} entity Original entity object
   */
  public constructor(message: string, private readonly entity: TEntity) {
    super(message);

    this.entity = entity;
  }

  /**
   * Get instance of the entity that could not be processed
   */
  public getEntity = () => this.entity;
}
